import Cookies from "js-cookie";

export const saveToken = (token) => {
  try {
    if (token) {
      Cookies.set("token", token);
      console.log("Token saved successfully:", token);
    }
  } catch (error) {
    console.error("Failed to save token:", error);
  }
};

export const getToken = () => {
  try {
    const token = Cookies.get("token");
    if (token) {
      console.log("Token retrieved successfully");
      return token;
    }
    return null;
  } catch (error) {
    console.error("Failed to get token:", error);
    return null;
  }
};

export const removeToken = () => {
  try {
    Cookies.remove("token", { path: "/" });
    console.log("Token removed successfully");
  } catch (error) {
    console.error("Failed to remove token:", error);
  }
};

// Clear all cookies
export const clearAllCookies = () => {
  try {
    Cookies.remove("token");
    Cookies.remove("is_blocked");
    Cookies.remove("user");
    Cookies.remove("isLoggedIn");
    Cookies.remove("access_token");
    Cookies.remove("refresh_token");
    console.log("All cookies cleared");
  } catch (error) {
    console.error("Failed to clear cookies:", error);
  }
};
